import React, { FC, useContext, useState } from 'react'
import { Box, Carousel, Image, ResponsiveContext } from 'grommet'
import { withPrefix } from 'gatsby'
import { useLayoutConfig } from '../../custom-hooks/useLayoutConfig'
import Loader from '../loader/Loader'

const HomeCarousel: FC = () => {
  const layoutConfig = useLayoutConfig()
  const carousels = layoutConfig.homeCarousel
  const [loading, setLoading] = useState(true)
  const hideLoader = (): void => setLoading(false)
  const size = useContext(ResponsiveContext)

  return (
    <Box height={size !== 'large' ? 'medium' : 'large'}>
      {loading && <Loader />}
      <Carousel play={2500} fill onLoad={hideLoader}>
        {carousels.map((carousel) => (
          <Image fit="cover" key={carousel} src={withPrefix(carousel)} />
        ))}
      </Carousel>
    </Box>
  )
}

export default HomeCarousel
